<template>
  <custom-dialog class="reset-password-bd" :title="model.title" :visible="visible" v-on="$listeners" width="480px">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item prop="pwd">
          <el-input :type="inputType" v-model="form.pwd" :placeholder="$t('reset_pwd_dialog_qsrxmm')">
            <i class="icon icon-xianshi" style="font-size: 16px; margin-right: 8px" v-if="inputType === 'text'" @click="inputType = 'password'" slot="suffix"></i>
            <i class="icon icon-yincang" style="font-size: 16px; margin-right: 8px" v-if="inputType === 'password'" @click="inputType = 'text'" slot="suffix"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <p class="tip">{{ $t('reset_pwd_dialog_mmwbxbhszfhzmrylz') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" :disabled="loading" @click="savePassword">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

// reset_pwd_dialog_mmwbxbhszfhzmrylz: 密码8-16位，必须包含数字、符号、字母任意两种// reset_pwd_dialog_qsrxmm: 请输入新密码// reset_pwd_dialog_cdyzgzfbxbhszfhzmrylz: 长度要在8~16个字符,必须包含数字、符号、字母任意两种// reset_pwd_dialog_bxbhszfhzmrylz: 必须包含数字、符号、字母任意两种

export default {
  mixins: [dialogMixins],
  data() {
    return {
      inputType: 'password',
      loading: false,
      form: {
        pwd: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        pwd: [
          {
            required: true,
            min: 8,
            max: 16,
            message: this.$t('reset_pwd_dialog_cdyzgzfbxbhszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('reset_pwd_dialog_bxbhszfhzmrylz'),
          },
        ],
      };
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_reset_pwd_dialog');},
  methods: {
    i18nCallback() {
      this.rules.pwd[1].validator = (rule, value, callback) => {
        const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
        if (!reg.test(value.toString())) {
          callback(new Error());
        } else {
          callback();
        }
      };
    },
    // 重置密码
    savePassword: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(
          apis.ResetPwd,
          {
            userId: this.model.data,
            newPwd: this.form.pwd,
          },
          true
        ).then(() => {
          this.visible = false;
          this.$message({
            type: 'success',
            message: this.$t('com_handle_success'),
          });
        });
      });
    },
  },
};
</script>

<style lang="scss">
.reset-password-bd {
  .tip {
    line-height: 20px;
    padding-top: 10px;
    color: #b1b1b1;
    font-size: 12px;
    padding-left: 6px;
  }
}
</style>
